import { render, staticRenderFns } from "./ilmoitukset.vue?vue&type=template&id=3b1c898a&scoped=true&"
import script from "./ilmoitukset.vue?vue&type=script&lang=ts&"
export * from "./ilmoitukset.vue?vue&type=script&lang=ts&"
import style0 from "./ilmoitukset.vue?vue&type=style&index=0&id=3b1c898a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1c898a",
  null
  
)

export default component.exports